import React from 'react'
import { useRouter } from 'next/router'

export const SignUpIndicator = ({
  type = 'module',
  isSubscription = false,
  style,
}: {
  type?: 'module' | 'series'
  isSubscription?: boolean
  style?: React.CSSProperties
}) => {
  const router = useRouter()

  const text = `Sign up and create your MedShr account in order to ${
    isSubscription
      ? 'subscribe to'
      : type === 'module'
      ? 'start'
      : 'access the modules in'
  } this learning ${type}`

  return (
    <div
      className="fs-unmask"
      style={{
        padding: 10,
        background: 'gold',
        color: 'black',
        fontWeight: 700,
        textAlign: 'center',
        ...style,
      }}
    >
      <a
        href={`/join?referer=${router.asPath}`}
        style={{
          color: 'black',
          fontWeight: 700,
          fontSize: '16px',
        }}
      >
        {text}
      </a>
    </div>
  )
}
